import React from "react";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";
import { PAYMENT_MODES } from "../data/paymentModes";
import { fmtINR } from "../utils/formatters";
import { SegLabel } from "../WalkinBooking/Styles";
import {
  PrimaryCTAButton,
  PrimaryOutlinedCTAButton,
} from "../../common/Buttons";
import {
  KindCard,
  KindCardRow,
  KindRadioOuter,
  KindCardText,
  KindRadioInner,
  KindCardTitle,
} from "../WalkinBooking/steps/StepReview";

const PaymentStage = ({
  selectedBooking,
  paymentMode,
  setPaymentMode,
  paymentRef,
  setPaymentRef,
  computedLines,
  total,
  onBack,
  onComplete,
  subtotal,
  gstAmount,
  grandTotal,
}) => {
  return (
    <Wrap>
      {/* <Summary>
        <SummaryTitle>Summary</SummaryTitle>
        {computedLines.map((l, i) => (
          <Row key={i}>
            <span style={{ color: "#5c6b7f" }}>
              {l.desc}
              {l.qty > 1 ? ` × ${l.qty}` : ""}
            </span>
            <span style={{ color: COLORS.COLOR_DARK, fontWeight: 600 }}>
              {fmtINR(l.amount)}
            </span>
          </Row>
        ))}
        <Divider />
        <TotalRow>
          <span style={{ color: COLORS.COLOR_DARK }}>Total</span>
          <span style={{ color: COLORS.BTN_GREEN }}>{fmtINR(total)}</span>
        </TotalRow>
      </Summary> */}

      <Summary>
        <SummaryTitle>Summary</SummaryTitle>

        {computedLines.map((l, i) => (
          <Row key={i}>
            <LeftSection>
              <span>{l.desc}</span>

              <QtyText>
                Qty: {l.qty}
                {l.unit ? ` ${l.unit}` : ""}
                {l.unitPrice ? ` × ${fmtINR(l.unitPrice)}` : ""}
              </QtyText>
            </LeftSection>

            <AmountText>{fmtINR(l.amount)}</AmountText>
          </Row>
        ))}

        <Divider />

        <Row>
          <span>Sub Total</span>
          <AmountText>{fmtINR(subtotal)}</AmountText>
        </Row>

        <Row>
          <span>GST (18%)</span>
          <AmountText>{fmtINR(gstAmount)}</AmountText>
        </Row>

        <Divider />

        <TotalRow>
          <span>Total Amount</span>
          <span>{fmtINR(grandTotal)}</span>
        </TotalRow>
      </Summary>

      <Block>
        <SegLabel>Payment Mode *</SegLabel>

        <KindCardRow>
          {PAYMENT_MODES.map((m) => {
            const active = paymentMode.id === m.id;

            return (
              <KindCard
                key={m.id}
                $active={active}
                type="button"
                onClick={() => setPaymentMode(m)}
                role="radio"
                aria-checked={active}
              >
                <KindRadioOuter $active={active}>
                  {active && <KindRadioInner />}
                </KindRadioOuter>

                <KindCardText>
                  <KindCardTitle $active={active}>{m.label}</KindCardTitle>
                </KindCardText>
              </KindCard>
            );
          })}
        </KindCardRow>
      </Block>

      <Actions>
        <PrimaryOutlinedCTAButton
          variant="secondary"
          style={{ width: "110px", padding: "12px 12px", borderRadius: 8 }}
          onClick={onBack}
        >
          Back
        </PrimaryOutlinedCTAButton>
        <PrimaryCTAButton
          variant="gold"
          style={{ width: "auto", padding: "12px 12px", borderRadius: 8 }}
          onClick={onComplete}
        >
          {paymentMode === "razorpayLink"
            ? "Send Payment Link"
            : "Confirm & Generate Invoice"}
        </PrimaryCTAButton>
      </Actions>
    </Wrap>
  );
};

export default PaymentStage;

const Wrap = styled.div`
  padding: 20px 22px;
`;

const Block = styled.div`
  margin-bottom: 20px;
`;

const Summary = styled.div`
  background: #f8fafb;
  border: 1px solid ${COLORS.BORDER_GREY};
  border-radius: 8px;
  padding: 12px 18px;
  margin-bottom: 20px;
`;

const SummaryTitle = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 11px;
  color: #5c6b7f;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 8px;
  font-weight: 600;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: ${theme.fonts.primaryFontRegular};
  font-size: 12px;
  padding: 3px 0;
`;

const Divider = styled.div`
  height: 1px;
  background: ${COLORS.BORDER_GREY};
  margin: 8px 0;
`;

const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: ${theme.fonts.primaryFontBold};
  font-size: 14px;
  color: ${COLORS.COLOR_DARK};
`;

const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
`;

const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${theme.fonts.primaryFontRegular};
  color: ${COLORS.COLOR_DARK};
  gap: 4px;
`;

const QtyText = styled.span`
  font-size: 11px;
  color: #94a3b8;
`;

const AmountText = styled.span`
  color: ${COLORS.COLOR_DARK};
  font-weight: 600;
`;
